import React, { FC, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Grid,
  TextField,
  Fade,
} from '@mui/material';
import { Modal } from '../../components';
import { Save, Close } from '@mui/icons-material';
import { IRepresentedBy } from '../../models';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { theme } from '../../styles';

interface AddEditRepresentedByModalProps {
  open: boolean;
  representedBy?: IRepresentedBy;
  onClose: () => void;
  onSave: (updatedRepresentedBy: IRepresentedBy) => void;
}

export const AddEditRepresentedByModal: FC<AddEditRepresentedByModalProps> = ({
  open,
  representedBy,
  onClose,
  onSave,
}) => {
  const classes = useStyles();
  const [localRepresentedBy, setLocalRepresentedBy] = useState<IRepresentedBy>(representedBy ? { ...representedBy } : IRepresentedBy.getDefault());

  useEffect(() => {
    if (open) {
        setLocalRepresentedBy(representedBy ? { ...representedBy } : IRepresentedBy.getDefault());
    }
  }, [open, representedBy]);

  const handleChange = (field: keyof IRepresentedBy, value: any) => {
    setLocalRepresentedBy(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    onSave(localRepresentedBy);
  };

  const isSaveDisabled =
    !localRepresentedBy.role;

  return (
    <Modal
      maxWidth="sm"
      open={open}
      onClose={onClose}
      title={localRepresentedBy.representedById ? 'Edit Represented By' : 'Add Represented By'}
    >
      <Fade in={open}>
        <Box component="form" autoComplete="off" className={classes.form}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                label="Role"
                fullWidth
                variant="outlined"
                value={localRepresentedBy.role || ''}
                onChange={e => handleChange('role', e.target.value)}
              />
            </Grid>
            
          </Grid>
          <Grid container spacing={1} justifyContent="flex-end" className={classes.buttonRow}>
            <Grid item>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleSave}
                disabled={isSaveDisabled}
                startIcon={<Save />}
              >
                Save
              </Button>
            </Grid>
            <Grid item>
              <Button variant="contained" onClick={onClose} startIcon={<Close />}>
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
};

const useStyles = makeStyles<Theme>(() => ({
  form: {
    padding: theme.spacing(1),
    width: '100%',
    boxSizing: 'border-box',
  },
  buttonRow: {
    marginTop: theme.spacing(1),
  },
}));
